import {
  ComponentPropsWithoutRef,
  ElementType,
  PropsWithChildren,
} from 'react'
import cx from 'classnames'
import styles from './GlassSurface.module.css'

type GlassSurfaceVariants = 'card' | 'panel' | 'input'

type GlassSurfaceProps<T extends ElementType = 'div'> = {
  component?: T
  className?: string
  variant?: GlassSurfaceVariants
} & Omit<
  ComponentPropsWithoutRef<T>,
  'component' | 'className' | 'variant'
>

export function GlassSurface<T extends ElementType = 'div'>({
  component,
  className,
  variant = 'card',
  style,
  children,
  ...props
}: PropsWithChildren<GlassSurfaceProps<T>>) {
  const Component = component || 'div'
  return (
    <Component
      {...props}
      className={cx(
        className,
        styles.GlassSurface,
        styles[`glassSwatch--${variant}`]
      )}
      style={style}
    >
      {children}
    </Component>
  )
}
